import { encryption, decrypt } from "utils"
import instance from "../../../interceptor"
import { reverseBuildModel, reverseBuildModelForApp } from "utils/reverseBuildModel.js"
import { buildModel } from "utils/buildModel.js"
import { data_dictionary_map } from "../../../../static/dataDictionary"
import api from "../../../api/index"
import { DEFAULT_PAGELIST_ID, DEFAULT_PAGEDETAIL_ID } from "consts"

/**
 * 1、创建图文组件子页面
 * 2、获取子页面模版数据
 * 3、根据模版数据更新子页面数据
 * 4、将子页面id绑定在图文组件上
 * @appId 应用id
 * @pageType 子页面类型
 * @errPageId 错误页面id
 */

export async function createSubPageHandle(appId, pageType, errPageId) {
  const res = await createPage.call(this, pageType, errPageId)
  const subPageId = res.data.data.id
  const appV = res.data.data.appV
  const pcV = res.data.data.pcV
  // 更新子页面映射关系
  const subPageMapping = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page?.subPages))
  const index = this.$store.state[this.request_prefix].page?.subPages.findIndex(item => item.appId === appId)
  subPageMapping[index][`${pageType}Id`] = subPageId
  subPageMapping[index][`${pageType}IsUseSystemTemplate`] = false

  if (this.request_prefix === "stage") {
    this.$store.dispatch("stage/changeSubPageMapping", subPageMapping)
    // 如果当前存在移动端数据
    if (this.$store.state.appStage.page.subPages) {
      const appSubPages = JSON.parse(JSON.stringify(this.$store.state.appStage.page.subPages))
      const index2 = appSubPages.findIndex(item => item.appId === appId)
      if (index2 !== -1) {
        // 如果存在当前应用的数据,则更新当前应用的移动端数据
        appSubPages[index2] = subPageMapping[index]
      }
      this.$store.dispatch("appStage/changeSubPageMapping", appSubPages)
    }
  } else {
    this.$store.dispatch("appStage/changeSubPageMapping", subPageMapping)
  }

  // 获取当前模板的内容
  const subPageRes = await getAllContent(subPageMapping[index][`${pageType}TemplateId`])
  let subPageTemplateData = subPageRes.data.data.content
  let subPageAppTemplateData = subPageRes.data.data.appContent
  subPageTemplateData = decrypt(JSON.stringify(JSON.parse(subPageTemplateData)), data_dictionary_map)
  reverseBuildModel(subPageTemplateData)
  if (subPageAppTemplateData) {
    subPageAppTemplateData = decrypt(JSON.stringify(JSON.parse(subPageAppTemplateData)), data_dictionary_map)
    reverseBuildModelForApp(subPageAppTemplateData)
  }

  // this.$message({
  //   customClass: "bigScreen_msg_backGroud",
  //   duration: 3000,
  //   type: "success",
  //   message: pageType === "listPage" ? "列表页创建成功" : "详情页创建成功"
  // })

  await updatePageData.call(this, subPageId, subPageTemplateData, subPageAppTemplateData, pcV, appV, pageType)
  return Promise.resolve({
    code: 200,
    msg: "success",
    data: {}
  })
}

/**
 * 创建轮播组件的子页面
 */
export async function createSwiperSubPageHandle() {
  const menuType = this.context.request_prefix === "stage" ? "menu" : "appMenu"
  const detailPageTypeName = this.context.request_prefix === "stage" ? "详情页模板" : "移动端详情页模板"

  const detailPageEncId = this.context.$store.state[menuType].menu.otherTypes.filter(
    item => item.name === detailPageTypeName
  )[0].encId

  const container_id = this.context.myid?.container_id || this.context.ids?.container_id
  const rect_id = this.context.myid?.rect_id || this.context.ids?.rect_id

  const detailPageRes = await getTemplateData.call(this, detailPageEncId)
  const detailPageTemplateData = detailPageRes.data.data.PageInfo.list[0].content

  Promise.all([createPage.call(this, "detailPage")]).then(res => {
    let detailPageId = null
    // 将加密数据解密
    try {
      for (let i = 0; i < res.length; i++) {
        const result = res[i].data
        if (result.status === 200) {
          switch (i) {
            case 0:
              detailPageId = result.data
              break
          }
        }
      }
    } catch (error) {
      console.log("error", error)
    }

    // 根据模版数据更新子页面数据
    this.context.$changeOptionsEV(detailPageId, "detailPageId", false, null, {
      container_id: container_id,
      rect_id: rect_id
    })

    // 保存子页面模版id
    this.context.$changeOptionsEV(detailPageTemplateEncId, "detailPageTemplateEncId", false, null, {
      container_id: container_id,
      rect_id: rect_id
    })

    Promise.all([updateSwiperPageData.call(this, detailPageId, detailPageTemplateData)]).then(res => {
      console.log("res", res)
    })
  })
}

/**
 * 创建导航组件的子页面
 */
export async function createNavMenuSubPageHandle(appId) {
  const container_id = this.ids.container_id
  const rect_id = this.ids.rect_id
  this.context = this
  const res = await createPage.call(this, "listPage")
  const subPageId = res.data.data.id
  const appV = res.data.data.appV
  const pcV = res.data.data.pcV

  // 更新子页面映射关系
  const subPageMapping = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page?.subPages))
  const index = this.$store.state[this.request_prefix].page?.subPages.findIndex(item => item.appId === appId)

  console.log(">>>", subPageMapping, index)

  // 获取当前模板的内容
  const subPageRes = await getAllContent.call(this, subPageMapping[index][`listPageTemplateId`])
  let subPageTemplateData = subPageRes.data.data.content
  let subPageAppTemplateData = subPageRes.data.data.appContent
  subPageTemplateData = decrypt(JSON.stringify(JSON.parse(subPageTemplateData)), data_dictionary_map)
  reverseBuildModel(subPageTemplateData)
  if (subPageAppTemplateData) {
    subPageAppTemplateData = decrypt(JSON.stringify(JSON.parse(subPageAppTemplateData)), data_dictionary_map)
    reverseBuildModelForApp(subPageAppTemplateData)
  }
  // 根据模版数据更新子页面数据
  this.context.$changeOptionsEV(subPageId, "listPageId", false, null, {
    container_id: container_id,
    rect_id: rect_id
  })
  await updatePageData.call(this, subPageId, subPageTemplateData, subPageAppTemplateData, pcV, appV, "listPage")
}
/**
 *
 * @param {*} type
 * @param {*} errPageId
 * @return
 */
async function createPage(type, errPageId) {
  let pageId
  const { websiteId } = this.$store.state.states.getDataPageIds
  // if (process.env.VUE_APP_MODE === "test" || process.env.NODE_ENV === "development") {
  //   if (type === "listPage") {
  //     pageId = "3fd06063163e3111ed09e881cb8cf30821d8"
  //   } else {
  //     pageId = "0b40694e5b194111ed083687611061651518"
  //   }
  // } else {
  if (type === "listPage") {
    pageId = DEFAULT_PAGELIST_ID
  } else {
    pageId = DEFAULT_PAGEDETAIL_ID
  }
  // }
  // 如果有错误的pageId，就用错误的pageId
  if (errPageId) {
    pageId = errPageId
  }
  let options = this.options
  let name = options && options.name ? options.name : type === "listPage" ? "列表页" : "详情页"
  return this.$API.addSubPage({
    p: pageId,
    w: websiteId,
    n: name
  })
}

/**
 * 获取子页面模版数据
 * @param {*} encId
 */
export async function getTemplateData(encId) {
  return instance.get(`v2/type/${encId}/list-enc?p2=1`)
}

/**
 *
 * @param {*} encId
 * @returns
 */
export async function getAllContent(encId) {
  return api.queryComponentContent({
    encId: encId,
    all: true
  })
}

/**
 * 更新自由布局组件的子页面数据
 * @param {*} subPages
 * @param {*} data
 * * @param {*} appData
 * @param {*} type
 * @returns
 */
export async function updatePageData(subPageId, data, appData, pcV, appV, type) {
  const portalData = {
    encPageId: subPageId,
    list: 1,
    domain: "138498cvm",
    w: this.$store.state.states.getDataPageIds.websiteId
  }
  const pcWidth = 192
  const appWidth = 41.4
  const param = handleSubPageData.call(this, type, data)
  param.version = pcV + 1
  let paramApp
  if (Object.keys(appData).length > 0) {
    // 说明是双端样式
    paramApp = handleSubPageData.call(this, type, appData)
    paramApp.version = appV + 1
  } else if (Object.keys(appData).length === 0 && this.request_prefix === "appStage") {
    // 说明是移动端样式
    param.version = appV + 1
  }

  // 手动保存子页面数据
  if (this.request_prefix === "stage") {
    portalData.app = 0
    buildModel(param, pcWidth)
  } else {
    portalData.app = 1
    buildModel(param, appWidth)
  }
  /**
   * 如果需要向后台传递网页json，使用该方法加密后传递
   */
  if (!!paramApp) {
    const temp = JSON.parse(encryption(param, data_dictionary_map))
    buildModel(paramApp, appWidth)
    const tempApp = JSON.parse(encryption(paramApp, data_dictionary_map))
    portalData.content = temp
    portalData.appContent = tempApp

    portalData.content.page = JSON.parse(JSON.stringify(portalData.content.page).replace(/&quot;/g, "&qquot;"))
    portalData.appContent.page = JSON.parse(JSON.stringify(portalData.appContent.page).replace(/&quot;/g, "&qquot;"))
    return this.$API.saveWebJsonPcApp({
      app: portalData.app,
      webJson: portalData
    })
  } else {
    const temp = JSON.parse(encryption(param, data_dictionary_map))
    portalData.content = temp

    portalData.content.page = JSON.parse(JSON.stringify(portalData.content.page).replace(/&quot;/g, "&qquot;"))

    return this.$API.saveWebJson({
      app: portalData.app,
      webJson: portalData
    })
  }
}

function handleSubPageData(type, data) {
  const page = JSON.parse(JSON.stringify(data))
  let param = {}
  param.page = page
  param.type = type
  param.event = this.$event.allEvents()
  return param
}

/**
 * 更新轮播组件的子页面数据
 * @param {*} pageId
 * @param {*} data
 * @param {*} type
 * @returns
 */
export async function updateSwiperPageData(encPageId, data) {
  const { appId, moduleId, engineInstanceId, myFetchParam } = this.rectAttr.options
  const { pageId, websiteId, wfwfid } = this.context.$store.state.states.getDataPageIds
  const pcWidth = 192
  const appWidth = 41.4
  const page = JSON.parse(JSON.stringify(data))
  let param = {}
  param.page = page
  param.version = param.version ? param.version + 1 : this.context.$store.state[this.context.request_prefix].version + 1
  param.type = "detailPage"
  param.event = this.context.$event.allEvents()
  param.page.homePageId = pageId
  param.page.listPageId = pageId

  console.log("param", param)
  const portalData = {
    encPageId: encPageId,
    list: 1,
    domain: "138498cvm"
  }
  // 手动保存子页面数据
  if (this.context.request_prefix === "stage") {
    portalData.app = 0
    buildModel(param, pcWidth)
  } else {
    portalData.app = 1
    buildModel(param, appWidth)
  }
  const temp = JSON.parse(encryption(param, data_dictionary_map))
  portalData.content = temp
  /**
   * 如果需要向后台传递网页json，使用该方法加密后传递
   */
  this.$API
    .saveWebJson({
      app: portalData.app,
      webJson: portalData
    })
    .then(res => {
      this.context.$message({
        customClass: "bigScreen_msg_backGroud",
        duration: 3000,
        type: "success",
        message: res.data.message
      })
    })
}

/**
 * 新增应用时增加对系统子页面的引用关系
 * 列表页 3fd06063163e3111ed09e881cb8cf30821d8
 * 详情页 0b40694e5b194111ed083687611061651518
 * @appId
 * @isSearchComponent
 * @isNavComponent 是否是导航组件
 */
export async function addSubPageMapping(appId, isSearchComponent, isNavComponent) {
  console.log("isSearchComponent", isSearchComponent)
  console.log("isNavComponent", isNavComponent)
  const menuType = this.request_prefix === "stage" ? "menu" : "appMenu"
  const listPageTypeName = this.request_prefix === "stage" ? "列表页模板" : "移动端列表页模板"
  const detailPageTypeName = this.request_prefix === "stage" ? "详情页模板" : "移动端详情页模板"
  let listPageEncId = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === listPageTypeName)[0]
    .encId
  const detailPageEncId = this.$store.state[menuType].menu.otherTypes.filter(
    item => item.name === detailPageTypeName
  )[0].encId

  // 现在的搜索列表页默认都是站内检索列表页，搜索列表页是一级分类样式模版， 站内检索列表页是二级分类样式模版
  if (isSearchComponent) {
    const firstLevelName = this.request_prefix === "stage" ? "搜索列表页" : "移动端搜索列表页"
    const secondLevelName = this.request_prefix === "stage" ? "站内检索列表页" : "移动端站内检索列表页"
    listPageEncId = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === firstLevelName)[0].encId
  }
  if (isNavComponent) {
    const firstLevelName = this.request_prefix === "stage" ? "导航列表页" : "移动端导航列表页"
    listPageEncId = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === firstLevelName)[0].encId
  }

  const listPageRes = await getTemplateData.call(this, listPageEncId)

  const detailPageRes = await getTemplateData.call(this, detailPageEncId)

  const listPageTemplateEncId = listPageRes.data.data.PageInfo.list[0].encId
  const detailPageTemplateEncId = detailPageRes.data.data.PageInfo.list[0].encId

  let subPages = []
  if (this.$store.state[this.request_prefix].page.subPages) {
    subPages = this.$store.state[this.request_prefix].page.subPages
  }
  // let listPageTemplateId = "3fd06063163e3111ed09e881cb8cf30821d8"
  // let detailPageTemplateId = "0b40694e5b194111ed083687611061651518"
  // if (process.env.VUE_APP_MODE !== "test" && process.env.NODE_ENV !== "development") {
  let listPageTemplateId = DEFAULT_PAGELIST_ID
  let detailPageTemplateId = DEFAULT_PAGEDETAIL_ID
  // }
  let subPageMappingItem = {
    appId: appId,
    listPageIsUseSystemTemplate: true, // 列表页是否使用系统模板
    listPageId: listPageTemplateId,
    listPageTemplateId: listPageTemplateEncId,
    listPageSetting: {
      showApplicationName: true,
      showBreadCrumbs: true,
      showNavMenu: true,
      showSearchComponent: true
    },
    detailPageIsUseSystemTemplate: true, // 详情页是否使用系统模板
    detailPageId: detailPageTemplateId,
    detailPageTemplateId: detailPageTemplateEncId,
    detailPageSetting: {
      showBreadCrumbs: true,
      showPrevNext: true
    },
    highSetting: {}
  }
  if (isNavComponent) {
    subPageMappingItem.nav = true
  }
  // 搜索改版隔离
  if (isSearchComponent) {
    subPageMappingItem.newSubSearch = true
  }
  subPages.push(subPageMappingItem)
  if (this.request_prefix === "stage") {
    this.$store.dispatch("stage/changeSubPageMapping", subPages)
  } else {
    this.$store.dispatch("appStage/changeSubPageMapping", subPages)
  }
  // this.$store.dispatch("stage/changeSubPageMapping", subPages)
  // this.$store.dispatch("appStage/changeSubPageMapping", subPages)

  return new Promise((resolve, reject) => {
    resolve()
  })
}
/**
 * 更新应用的子页面配置项时时更新对系统子页面的引用关系
 * 如果是pc端的操作，则更新双端，如果是移动端，则更新移动端
 */
export function updateSubPageMapping(subPages, appId, prefix) {
  const _appId = appId ? appId : this.options.appId
  const _prefix = prefix ? prefix : this.request_prefix
  if (_prefix === "stage") {
    this.$store.dispatch("stage/changeSubPageMapping", subPages)
    // 找到subPages中当前应用的数据
    const index = subPages.findIndex(item => item.appId === _appId)
    // 如果当前存在移动端数据
    if (this.$store.state.appStage.page.subPages) {
      const appSubPages = JSON.parse(JSON.stringify(this.$store.state.appStage.page.subPages))
      const index2 = appSubPages.findIndex(item => item.appId === _appId)
      if (index2 !== -1) {
        // 如果存在当前应用的数据,则更新当前应用的移动端数据
        appSubPages[index2] = subPages[index]
      }
      this.$store.dispatch("appStage/changeSubPageMapping", appSubPages)
    }
  } else {
    this.$store.dispatch("appStage/changeSubPageMapping", subPages)
  }
}

/**
 * 生成一个子页面id
 * @param {*} appId
 * @param {*} pageType
 * @returns
 */
export async function generateSubPageIdHandle(pageType, appId) {
  // 在自定义当前端子页面前，先判断当前应用是否已经生成过其他端的子页面,如果是，则直接使用，否则创建
  let subPageId = null
  let res = null
  if (this.request_prefix === "stage") {
    let appSubPage = localStorage.getItem("subPageSetting-" + appId + "-appStage")
    if(appSubPage ){
      appSubPage = JSON.parse(appSubPage)
    }
    if (appSubPage && !appSubPage[`${pageType}IsUseSystemTemplate`]) {
      subPageId = appSubPage[`${pageType}Id`]
    } else {
      res = await createPage.call(this, pageType)
      subPageId = res.data.data.id
    }
  }
  if (this.request_prefix === "appStage") {
    let subPage = localStorage.getItem("subPageSetting-" + appId + "-stage")
    if(subPage){
      subPage = JSON.parse(subPage)
    }
    if (subPage && !subPage[`${pageType}IsUseSystemTemplate`]) {
      subPageId = subPage[`${pageType}Id`]
    } else {
      res = await createPage.call(this, pageType)
      subPageId = res.data.data.id
    }
  }
  return Promise.resolve(subPageId)
}

/**
 * 生成子页面
 * @param {*} subPageId
 * @param {*} pageType
 * @param {*} templateId
 * @returns
 */
export async function generateSubPageHandle(subPageId, pageType, templateId) {
  let pcV = 1, appV = 1
  // 获取当前subPageId对应的双端版本号
  const pcVData = await getPageVersion(subPageId, 0)
  if (pcVData.data.data) {
    pcV = pcVData.data.data
  }
  const appVData = await getPageVersion(subPageId, 1)
  if (appVData.data.data) {
    appV = appVData.data.data
  }


  // 获取当前模板的内容
  const subPageRes = await getAllContent(templateId)
  let subPageTemplateData = subPageRes.data.data.content
  let subPageAppTemplateData = subPageRes.data.data.appContent
  subPageTemplateData = decrypt(JSON.stringify(JSON.parse(subPageTemplateData)), data_dictionary_map)
  reverseBuildModel(subPageTemplateData)
  if (subPageAppTemplateData) {
    subPageAppTemplateData = decrypt(JSON.stringify(JSON.parse(subPageAppTemplateData)), data_dictionary_map)
    reverseBuildModelForApp(subPageAppTemplateData)
  }

  await updatePageData.call(this, subPageId, subPageTemplateData, subPageAppTemplateData, pcV, appV, pageType)
  return Promise.resolve()
}

/**
 * 
 * @param {*} pageId 
 * @param {*} type 
 * 当前t=4时，该接口返回版本号
 * @returns 
 */
async function getPageVersion(pageId, type) {
  return instance.get(
    `v2/webjson/edit/${pageId}/content?a=${type}&t=4`
  )
}
